import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './contexts/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Specialties from './pages/Specialties';
import LabTests from './pages/LabTests';
import HealthPackages from './pages/HealthPackages';
import Pharmacy from './pages/Pharmacy';
import CorporateHealth from './pages/CorporateHealth';
import Contact from './pages/Contact';
import HealthCard from './pages/HealthCard';
import AdminDashboard from './pages/AdminDashboard';
import DownloadReports from './pages/DownloadReports';
import StaffPortal from './pages/staff/StaffPortal';
import MasterCheckup from './pages/MasterCheckup';
import B2BTracker from './pages/B2BTracker';
import FranchisePortal from './pages/FranchisePortal';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = () => (
  <div className="App min-h-screen flex flex-col">
    <Header />
    <main className="flex-grow">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/master-checkup" element={<MasterCheckup />} />
        <Route path="/specialties" element={<Specialties />} />
        <Route path="/lab-tests" element={<LabTests />} />
        <Route path="/health-packages" element={<HealthPackages />} />
        <Route path="/pharmacy" element={<Pharmacy />} />
        <Route path="/corporate" element={<CorporateHealth />} />
        <Route path="/health-card" element={<HealthCard />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/download-reports" element={<DownloadReports />} />
      </Routes>
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/staff" element={<StaffPortal />} />
          <Route path="/b2b" element={<B2BTracker />} />
          <Route path="/franchise" element={<FranchisePortal />} />
          <Route path="/*" element={<PublicLayout />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;